import { render, staticRenderFns } from "./RelatoriosDialog.vue?vue&type=template&id=2ca4be90"
import script from "./RelatoriosDialog.vue?vue&type=script&lang=js"
export * from "./RelatoriosDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports